const AB_RATIO = [40, 100] // b군이 광고 오픈된 그룹

const ALFARM_CLICK_AD_EXCEPTION = [
  '62be7015f3d13567a42edffb',
  '6386ff93f3dc0105f96ab431',
  '6201ccea74c0b48a8f8ae6e2',
  '65756ddd35e93108e60f29ed',
  '665a66cd4b1519dde58b0d15',
  '673e930ad751ccf89c3984f3',
  '623c2957969fc38dc46fc2fa',
  '65cb7a811f430aba20086480',
  '64c352cffad3ecb135bcdc05',
  '6640985bfdc5bf488574578d',
  '660e0832c5ca65d3b3a4ff91',
  '67370564691c16d443e62c29',
  '66770ef95a1a00e4867c683e',
  '62f1187604af0e028a96729e',
  '643fc813ab39f88d041fa624',
  '6243ada4ddfd480eb6879a0f',
  '66c69256588c2cd89940e761',
  '625673d8a196431f74a39901',
  '660a22f7a77d4aa0bb4d0dec',
  '66b0482fbf9e74f1a2970f95',
  '679a18ed2ed15f2154a58dd4',
  '65756332cad6c7896887b9b5',
  '64d9bca29f4180dac44b029d',
  '65e6e232adbc773fca0ad9c0',
  '63d22429184a2261f43640d6',
  '6604d78b4c9a142e46503b50',
  '65fb971bcfe03a279ed2850d',
  '6422f143a56d9837dd5a4ba5',
  '65af4c0d6b7aab8ff6c50a7d',
  '67481abd5f7a64841d6f3c03',
  '62c3fbb37af7477b03183b94',
  '635234f1e88b7f0cea089616',
  '66dc5321770111c20f4c44e2',
  '62a1c41960882633ecace505',
  '64ffc72df4e92d73a84daa71',
  '6571bc4c1c0f130bbe3d4344',
  '64eea35ea3585edf05e2e542',
  '65bc4f2a819e8a0814e3e0d7',
  '642f6ce88049fb0930a8236d',
  '67b3f11f503b250ee165d34c',
  '635103d54332492c0cae216a',
  '621455aab27b976e73d1e52e',
  '66055f175e895dff3102668d',
  '66b258910b3013f2ab50bfad',
  '64f1b15432c090fc0066204a',
  '644a4125cff68d419d16fd47',
  '62843c8fe31bf342c8ecd81b',
  '6270dc184460b58d049cc6d5',
  '67736ceb91aab1be6cd35428',
  '6200d58f558d4f7e5b590d6c',
  '64ddd7e258dc24d0c7a08c9f',
  '626ba41c8b7c3f04370b5eaa',
  '66eab1610b814b11531fbcb7',
  '65ba1f9142411760ab85a818',
  '6256c56085962823ac14a4a6',
  '64b89cbb21280e24d82db096',
  '65df496c4b77cf9983143b47',
  '660df6026a245ee522014e8a',
  '6555de8457b4f50642836546',
  '62da4fffa20e2b82303a4a1a',
  '65faf93b3d00d90947c3a8a4',
  '6448ed1d6feaf22b008cfa4e',
  '62bd5e12a2a55a0c6bdd4a05',
  '643e1a74a2ee3f2d7f63bd8c',
  '65796bdadaf0ff2a91e85e94',
  '62830cde5b8a630e1718fad9',
  '652dfaa1c96461cbe319554e',
  '62fdc7c43fd9917fa33ef245',
  '67c6472065c1b7fabf94d33e',
  '67b40724083c72aabce9cbc0',
  '677a40a6d13a918338ed7f48',
  '65e9228b5dde3aea86fa7f3a',
  '6396916bd3be323f6b8ec6c3',
  '64b8c3927a92907a52396c62',
  '659f6ee14b4eaecf687fa27d',
  '668764f473b913a69aaafe50',
  '621843790f908923f10fc6ac',
  '64a1850a8e700ec16cc15b16',
  '64ba4e8c6709f4af161f8de5',
  '62553730d4da324ff46cae12',
  '66ea3d8d5b414692bd5df3a3',
  '6679407ec870768af5e5b389',
  '66e3ead2eb3419fb67fd34bc',
  '64b89f96a8ecc3ef13cfeb97',
  '673dc79073c8d418e9e92443',
  '6462c549d033c6e58e9ebf04',
  '64e6a53428ecd0d3eef1d94c',
  '671b3e1da3be9a5788d6c5b4',
  '6693e46bd024efd15b1f53be',
  '61e104dd8fb92655cb61f809',
  '66a352e14d197875c10c29b5',
  '660ab7cfc01b56f45d04ff67',
  '65eea82dff4c0b42404b4165',
  '65f04a8bf46ab72cd95722c4',
  '6423e447afcdd16effab0d87',
  '623e705b64063f8db971cfb8',
  '665d15ec19fc5afa3684c547',
  '675d8cb1c8b6e4450ebb6136',
  '624158c270b86d4f3e40fafc',
  '655ee2b02bb425371812a785',
  '664b10452cf548ee2f3649ba',
  '6582bcb600a8b6f99d0f12f7',
  '65decef2cb9534a71bf0bf9b',
  '67742c8ae8eade284f90a523',
  '67cfa72d4364433d80c2699f',
  '64ec3f8133a3f381b0f0068e',
  '637ef16ced4d225943109efa',
  '668b3ea64941c6881665f7ff',
  '66629e3b4e64815c7a98a096',
  '65c4623c6fd89a4c8339ebe8',
  '6241c1306b68e53328ca834d',
  '62e764cf9d6b9f2f869e20aa',
  '6627624430781328b5f23bb3',
  '65ae3232125a74b298bdd5ae',
  '643fa257d38834c44729961f',
  '6487e03ae8e50a1b588c789d',
  '65beae37260d7f41b440e497',
  '6625d769b185871f273a7c97',
  '64b4e090b437b090f3750316',
  '67aad5971005e45928954f69',
  '647eaae6d1e8d47c0f49d128',
  '6487d6bb3429d760ee2800b7',
  '6454d19e967f43399b85c450',
  '64b10ad86a55be5e89b73f8a',
  '6686681939dd8ce68e20d4eb',
  '6656edcd5630f3d0aa00bae7',
  '64bddf1ae33ba6d09c1ded62',
  '65e80126fb7c8d7229d6c285',
  '67c133198aabd9c55d6e6b13',
  '66ae3fc75d3481b1859e74d3',
  '64a79d6e5b42cc4cbeb7605f',
  '646ef92171aa38a1658df394',
  '66150ddb44401ccf7b43b7ae',
  '659b52674da3f844470527a7',
  '65cc5d0ae15b30c6b6901226',
  '65fbbab0d3ccbfb71c493525',
  '66df8dd5e84ba68dcc545a49',
  '63d89e0bc7525c05998a9933',
  '63b22f65e779ef96771ef48b',
  '65ae0b280318079b6fdffeb9',
  '63e1e1d4177df316ce63b8ab',
  '6350b060c73b61bea24c1820',
  '650763b04276a40320138b13',
  '65ffa230a1dd914fc798b96a',
  '61714a79e5a3e831133b00c2',
  '66d69ea34c432819be891c76',
  '64ee9ee89abf3164dcaf69df',
  '67dd65ffc16cd3f029c90b48',
  '643f3d9b636e64c3991a489a',
  '6752e841d34f09ab433cdf85',
  '6723152889130670cae5464e',
  '637da6b4e12d8244628dbfdf',
  '65f9b7be65005b17f2d36902',
  '66fcdf8cdd751795f56854cf',
  '64407b9ff618a2a6b0e680a0',
  '63f5a3df6e9d27075baab83c',
  '67a972e3e2915fea19cc7787',
  '67d52a394b510bb430f07d4e',
  '67ae9e450d1be0599ad9a19d',
  '62eb72117d09c9209fefc3b1',
  '6594a7b082432e188b2145e6',
  '67da40a0d8fbc7fcbb45c13f',
  '6436841f3aab0875e887003d',
  '65866c43b21d3560aaaca43e',
  '65e580269fdc965997a657fd',
  '620c496e4dafe41acb21ba1c',
  '6322d21b18e0e37622626319',
  '630067e2ca7cd47e57d14050',
  '625e74f105863763ca5ab40c',
  '643f81a4571ac097a99ca4e6',
  '648935ebfa86632c0bcba1ba',
  '639ed823d8f68df37bc6bde9',
  '67bffb28bd5041940a645485',
  '64e46c66081bd80bcdf8c281',
  '64d9aca850472cb6ed600ff0',
  '65e8569eecc5b6f43fa43153',
  '663e2f04fb78ee7b4ac70eae',
  '659a16d4581d71482003d744',
  '63f6bbba137419fcd87c87a8',
  '660d280da6e5aa52585ec0ec',
  '66ade18eb5e59327d71fb1bc',
  '62c3f1ac5e1c90058c49984e',
  '6250f760fd4f254120115b3c',
  '67c16262ac93d81d1c188c4e',
  '6290b35c33b61a6a42d3ff54',
  '649ced73261597e82fddabe7',
  '647a805597a37ae01a5734b0',
  '64845f1cb111857107386731',
  '65fbb1f55fcd575db7c81350',
  '6229503d501e7b809ce24e94',
  '65dfe66214373b2c7aa97d9d',
  '640abd42122b54d9dc488603',
  '643619e1b8a3bf1b76b45c03',
  '65f0e4628b749c45f09f27b3',
  '67c664836eab6caca68593cd',
  '66e1023235a7dca6b614e52b',
  '6649ba20da8cefa12c8b7bed',
  '647565934215dcb497e71d05',
  '64ed9b61cb53d2dd921a7402',
  '6666b25bc8a0bcceb0f269a9',
  '64c8950020e9364710530748',
  '6448929716a5d7572bd82dde',
  '64f6de4475bf26568696bb2a',
  '6479a5a89c14101ad7eeb451',
  '64f83249262ce4aee21a326c',
  '64361ab0d1e2111b6a2724e6',
  '6455b82762139e377456b5d0',
  '6371f0f86e6b2319b8554412',
  '6470b6e205837b27b2cf0c52',
  '656d74399e243d40368b2f15',
  '673f09ffb963b2b1f055577b',
  '63d3677c6f9abc16343d800b',
  '66b18f6eee6f46e7273dc168',
  '6416f8febd7467e097fbb153',
  '6260d929b7e327325ed34fec',
  '651a763c77a2f6e1fc5d662e',
  '65768d0a6ded11609df4bed2',
  '63d7707c3196d61b4b37045a',
  '6209a5aec4b9f13e144fdaa1',
  '651d4b6efed0dbc4cb9e14e2',
  '6527ba51a61001be1cc4db00',
  '63d389ac658c150dbf120190',
  '66da926f672ff510441ff24e',
  '65669fca8b2d44054a0e3d61',
  '64425917f57b6725822f4b38',
  '641baea295753b4124478ad1',
  '625e07c269a8d74757110205',
  '65fb89ede066959beea6c2a7',
  '62216a9bb2b70d5ac5cc523c',
  '62b09f0bf5983c7365b43123',
  '6666957cf773da5e0bc33768',
  '61a9dea6d45e15452cd398af',
  '64d8a424e9c5637a5b0898fe',
  '65b7c237d36abb2ea47bb939',
  '6746b47051395d71226db55b',
  '624910d38efd3628d3b32179',
  '64b0afdfe7c3f028b68b61a9',
  '629ca99d0a6e72489ebcf569',
  '64579c6d29007a90687e336b',
  '6278e16d6f86231201e71b04',
  '662f91257b19bb629168fc4e',
  '64fddc9c67c78d6704c3a614',
  '64f6feba2d74e45ef2b688ff',
  '6604ceaa72cd1241964016b9',
  '646ec55534bb4b615e35f95f',
  '61a8c6cfc0b55a72536b09a9',
  '63c146273f7d723b8d19c9ba',
  '645867657e0fdba298ce2100',
  '6490f55a005477292e52bcc2',
  '6269ec7d46fdc27f8c0f6ec9',
  '642bcdd002200db746d05d1f',
  '6436a0e5a6673ea0e0eaea27',
  '629588ece68a1a6b5e6e50ab',
  '6712af14e52eaabbae463e72',
  '65fe7bef6590a86f39045938',
  '667533df547b4dbb1ffe1a5e',
  '628f30405e91732401c753f7',
  '673e94ae677695107c68db8e',
  '62c16f7823393b1bfc92ecfc',
  '646ebdc2efcc3425179f9b29',
  '6639b2590faf2af09d9d1feb',
  '63d2365206f9182d11013f14',
  '67b92e2679185c0149dcee91',
  '663b5063e6191ed936bff12f',
  '63f069f2135dfa06589316e1',
  '649afbeb49df1753f2523ef2',
  '6281d6f6f402a58ca20a5221',
  '6731ef3af0adb9b7b95ae478',
  '645db7ac5b54a23fd96d8d0e',
  '64732991c98e2b926245185d',
  '647b08719020fdd919f174b0',
  '64e69e2edbdae3159dc17d97',
  '668e0a4b34560c0290ea3350',
  '649ba04d00b174f9a89708c0',
  '67b2883ddb601a65a5830685',
  '667ac1a344da1ad988ee80af',
  '63ece06143cbbf76e09a398b',
  '672c46c7ec91049a5e6ab40e',
  '64a79d83d9791f3cfd842509',
  '642a67386d350e8ca3173c44',
  '64d1e05f42bb67f7084b927b',
  '6688e43b523a20a27507a9b2',
  '67a02abacba5a3e2057a217e',
  '6350ffc8a295561a951d5765',
  '643cb700ca9ef8d87432c3b2',
  '6576a667c8de50bd46a9a621',
  '6392c62e4562bfa54474f261',
  '6357837124307e5017f67b6b',
  '6264139d10800935b579e030',
  '646c5b6b12b6f7a75fbbabac',
  '625375d472c8bd8ff96d70a6',
  '6345142a3ba521656ea1e5f7',
  '6205ab8371c9ac09b5fedb02',
  '66704659c32397f639c60949',
  '646d72834af90978308642fc',
  '65efbb76b003dca204483b3d',
  '6711eaa8a1fd7c1f6502ad66',
  '659124920bf17f21cde8738d',
  '62465b34e7836c42dbf9f594',
  '675a7f772f79d9a8cc6f1959',
  '62b12bc5dd96bd1f8b1a6bff',
  '62110da0c47dbf643c093f75',
  '664acf4ca9bbc216c7ab0ec0',
  '65b5fc82b86c5043c5bf2eb1',
  '6757addd46d3196701489be0',
  '66397368d333f72bf0729c78',
  '67a467989de322695989ce52',
  '67407571c76075e693235863',
  '65961c89f31e7d70b3e3f9fb',
  '6788bce943827e3cd5928917',
  '65bb8dff056b45cf463a8ce3',
  '65f2acb08ff9e54665632886',
  '676f9b309df7525fbb4eebf1',
  '6760125b2d51a2e8fad0dff4',
  '6269cf8b87c3781aaa9cc6c1',
  '634f86b9622d0a5d7a3d1598',
  '6455198c7c625be52457ac56',
  '67878f19c6245662847ef370',
  '623b2ae86cd33853481e2000',
  '67d76f3c5702f6d08f74a791',
  '62834249771b9b34a82efa25',
  '64d653be48c56c6412be7e4c',
  '63d8e7ea6b69e421303e139f',
  '659a4cc7a816740a555706d6',
  '6708f094dcfbbffa616d125b',
  '641815fcd363c5b61b925c3b',
  '664735ebfab7556316ed4c64',
  '67bd6b7c5cf5612cbebcf8e2',
  '62cb86493eea8b67a08c5114',
  '6229bc3aee266967b13eca4e',
  '65e890f17fbdd10f95c19d69',
  '6607bfa9b2756e46fcbaf033',
  '64b0c8c3dc540b7745ec9423',
  '66b1a052ef7b4b19af96c087',
  '63943e98dc275939a8e1c188',
  '643763fb928bf21c31e77fda',
  '62da28f87c91430455ae9f02',
  '66187a3ad6ab3ccc2c950b03',
  '65487005fe6bea0ff2425aed',
  '6629eba25cc14b48928eb0b4',
  '6618efb5ddc6ebd3527dabe1',
  '667b4d325262ec336ccaf9bd',
  '669f2d606c5fb1476d8dd0dc',
  '64d053d65978189b233d16d0',
  '65c084179eef934341e68d05',
  '62c3d8aa7158037552727dc0',
  '673ed5a56c66b9a30648b894',
  '623b00d7ee0e6b0bb6da88c2',
  '652138c3ec6d7c96d2a86cdf',
  '6494f389da722c43794cf240',
  '647927ecd4a504ff231d2791',
  '64547cd66ba393fbfbc6c700',
  '646713ad4903bfeb216a80d5',
  '653e0e1d87d8a1b95084506d',
  '671dcea2530e8a35aa064440',
  '6232fea08397a5341a303cde',
  '6278cae96019ca59edf93935',
  '673ea0a72df005c92101408c',
  '64279bb9a9f69c097d276049',
  '666b69edfef83c989de7b54e',
  '65e5656d9814ca4778b44ef0',
  '64f6e579c2af65f961cb46f3',
  '674bbf829f205c281ecca765',
  '6487f3b6cc9bdcf572535f12',
  '6336a583cb32257c09a9133b',
  '645b24cad6d46056933c2c6f',
  '65c3161c7100ad0d44c4f86e',
  '643f6cb7b145e2094b455c70',
  '6256261053683c8ef080875e',
  '627a05ffa385ad0641369d09',
  '65a8e1c7ddc8216c7a98f7e4',
  '658c4d33f9d347936faa781c',
  '65488cbca24ebcf9954df525',
  '65549be5341fbbca10eb8aa0',
  '626a2e0626034802bdeb8add',
  '664accd1a550b44047217eaa',
  '635757ecadd0cc7b28f3a339',
  '6250c311659b273ff80a3705',
  '6461d860db21f8171727b572',
  '6347936607b22850246406ce',
  '648a54a3f464f4dab286ed0b',
  '64d49e0d068243399f63bab5',
  '66cd92f84b7c1d578881931d',
  '648dbbc05bfa736a9e45ae86',
  '67c9517a0d35285e59262108',
  '676b860fd80e5047d0547bf9',
  '66b32be1d36b95a238ae8148',
  '663b6641b01d4140e752235e',
  '63cfa16e2d49a1375b69b6d5',
  '6446155d8d368e9567dde50e',
  '66a1d4840f850256e5a1cd77',
  '67d2fda30f33817b1d1687f1',
  '62c7a61ed9b07049d0c8fbc5',
  '67bec31aee46b71d6612e3f5',
  '62da9a6a45157c7a451d6116',
  '62b41aea01ab6b3c03a922ee',
  '62fee1d4e14318479f3b497f',
  '61fa132985108a0ff3b5d2b5',
  '67a825edf9e8ef6e0656ba61',
  '6552d731124eaebcbc9ed7ee',
  '64b660068a183822171a6b13',
  '63b5178485466d3b50b56892',
  '652fcc8ee10dc237de20d4e0',
  '620f4103759b3809ae5ceae8',
  '64852725dad8c34d31a4b0bf',
  '624ab33e616eb47658b58ab4',
  '67fbb6b2a13b04084a0895b6',
  '62a01a459add884e964eb209',
  '636270835340e760decbaa35',
  '65fbe864cfe03a279ed29c28',
  '658516ea85a56a53da5fccb1',
  '644336d1d299e725e62c08a8',
  '6257694d8095a36beef08f7c',
  '66025fa043ef5762bc8eb848',
  '646d82b39ef72ea150338d2b',
  '67af5b28346051b9695c6bcd',
  '635f75b197866604e583cbad',
  '64264ba95d1b450995cc065e',
  '6763c11e33b904301217a1a8',
  '6481735d5fb359e8f4d86ea6',
  '6535f7dc90d5d37677205174',
  '65b7bca4e5fca1babc72e744',
  '655490ac64340c0452ac75ef',
  '65f37eff0588bb105467d883',
  '655b1141d61acd6e56cace5d',
  '664d8cd1c3882c29301df111',
  '65fd0f2aa2f6ed4d44e676fa',
  '62c26c899d02e137aca1ce54',
  '6497c05fc8b5c2fe6aa8fb36',
  '6537287d84bab31652ba1172',
  '62679a178002a47212633231',
  '6641798ccc597a80e071dd06',
  '643d1b34de1904e63d37463c',
  '63520ea3e3cbce65cb341e28',
  '6663c73adf75dff060ff6726',
  '66c6b6a521f604ce54aa5056',
  '64b6357608a929c078c3b478',
  '63f60d0540f43f8a74481408',
  '649aa071ffa127f1d451cdab',
  '659cea8826ef0cc457008104',
  '627c5a43ff75754d72d98bcf',
  '6512e8adb647ba59bf2a4d3c',
  '6526cdd2c2babb906ae77139',
  '679732bcea4c53f2c9104882',
  '6449f66d6dbd6f6ad606f445',
  '63913b7e25cd58533188917d',
  '6523b34e8127246d7b2fc7ee',
  '660436e69ce527c58486d4b3',
  '6260ec50cdfaf746c5bbb1eb',
  '6254ef9cbf7f353e37bc683b',
  '65dc4665b097bca3a6f6f841',
  '65f67c3ff7b4b0737b7414bc',
  '6452304ce81f6e9530375975',
  '64e80bc31cd758d3b8c2fcdc',
  '62441a6bcdd870664bee3545',
  '679d6bd63c259a777767b08f',
]

export { ALFARM_CLICK_AD_EXCEPTION, AB_RATIO }
